import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=b41a5998&"
import script from "./breadcrumbs.vue?vue&type=script&setup=true&lang=js&"
export * from "./breadcrumbs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./breadcrumbs.vue?vue&type=style&index=0&id=b41a5998&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports